import { useAdminData } from "../state/AdminDataContext";

export function ToastHost() {
  const { toast } = useAdminData();
  if (!toast) return null;
  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: 24,
        zIndex: 200,
        background: "#20242E",
        color: "#fff",
        padding: "12px 20px",
        borderRadius: 14,
        fontSize: 13.5,
        fontWeight: 700,
        boxShadow: "0 14px 36px rgba(0,0,0,.26)",
        display: "flex",
        alignItems: "center",
        gap: 9,
        animation: "toastin .25s ease",
      }}
    >
      <span className="ms" style={{ fontSize: 19, color: "#F8A0B0" }}>
        check_circle
      </span>
      {toast}
    </div>
  );
}
